<app-table (actioned)="emit($event)" [params]="tableParams" [filterText]="filterText"></app-table>
